/*
 * Viretta recipe article (sections/v2-recipe.liquid, round 90).
 *  - the film: plays muted ONCE when it comes on screen (never with prefers-reduced-motion), then rests on its last frame –
 *    the finished dish; play / pause on the picture, sound, full screen, the time line; »Film« in the phone bar = full screen
 *  - »Mængde«: − 1× + scales every amount (the parsing of assets/vbs-sections.js: »900 g«, »7,5 dl«, »3–4«, »½«, »1 ¼«)
 *  - the method rows: a tap anywhere on a row ticks it
 *  - »Hold skærmen tændt«: Screen Wake Lock; the switch is only shown where the browser has it
 *  - the phone bar marks the part of the recipe that is on screen
 *  - »Udskriv«
 * »Gem opskriften« is the shared save in vbs-sections.js ([data-vbs-save], localStorage »vbs-saved«).
 */
(() => {
  const root = document.querySelector('[data-v2r]');
  if (!root || root.dataset.v2rReady) return;
  root.dataset.v2rReady = '1';
  const $ = (s, el) => (el || root).querySelector(s);
  const $$ = (s, el) => Array.from((el || root).querySelectorAll(s));
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- the film ---------- */
  const film = $('[data-v2r-film]');
  const video = film && $('video', film);
  if (video) {
    const timeEl = $('[data-v2r-time]', film); const lineEl = $('[data-v2r-line]', film);
    const playBtn = $('[data-v2r-play]', film); const soundBtn = $('[data-v2r-sound]', film);
    const fmt = (s) => { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); };
    const total = timeEl ? timeEl.textContent.split('/').pop().trim() : '';
    let playedOnce = false; let userPaused = false;
    const play = () => { try { const p = video.play(); if (p && p.catch) p.catch(() => {}); } catch (e) { /* ignore */ } };
    const toggle = () => { if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); } };
    playBtn.addEventListener('click', toggle);
    const pauseBtn = $('[data-v2r-pause]', film); if (pauseBtn) pauseBtn.addEventListener('click', toggle);
    video.addEventListener('play', () => { film.classList.add('is-playing'); playBtn.setAttribute('aria-label', 'Video pausieren'); });
    const rest = () => { film.classList.remove('is-playing'); playBtn.setAttribute('aria-label', playedOnce ? 'Video erneut abspielen' : 'Video abspielen'); };
    video.addEventListener('pause', rest);
    video.addEventListener('ended', () => { playedOnce = true; rest(); });
    video.addEventListener('timeupdate', () => {
      if (timeEl) timeEl.textContent = fmt(video.currentTime) + ' / ' + total;
      if (lineEl && video.duration) lineEl.style.width = Math.min(100, (video.currentTime / video.duration) * 100) + '%';
    });
    if (soundBtn) soundBtn.addEventListener('click', () => {
      video.muted = !video.muted; film.classList.toggle('is-sound', !video.muted);
      soundBtn.setAttribute('aria-pressed', String(!video.muted)); soundBtn.setAttribute('aria-label', video.muted ? 'Ton einschalten' : 'Ton aus');
    });
    const full = () => {
      userPaused = false;
      if (video.paused) play();
      if (video.requestFullscreen) { const p = video.requestFullscreen(); if (p && p.catch) p.catch(() => {}); }
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();          // iPhone
      else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
    };
    $$('[data-v2r-full]').forEach((b) => b.addEventListener('click', full));
    // In full screen the film is shown whole, with the browser's own controls
    const onFs = () => { const on = document.fullscreenElement === video || document.webkitFullscreenElement === video; video.controls = on; video.style.objectFit = on ? 'contain' : ''; };
    document.addEventListener('fullscreenchange', onFs); document.addEventListener('webkitfullscreenchange', onFs);
    // Plays by itself once, while it is on screen; off screen it pauses and goes on when it comes back – until it has ended
    if ('IntersectionObserver' in window && !reduce) {
      new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && e.intersectionRatio >= 0.5) { if (!playedOnce && !userPaused && video.paused) play(); }
          else if (!video.paused && !document.fullscreenElement && !document.webkitFullscreenElement) { video.pause(); userPaused = false; }
        });
      }, { threshold: [0, 0.5] }).observe(film);
    }
  }

  /* ---------- »Mængde« ---------- */
  const countEl = $('[data-v2r-count]');
  const qtyEls = $$('[data-v2r-qty]');
  const toNum = (s) => { if (s.includes('/')) { const p = s.split('/'); return parseFloat(p[0]) / parseFloat(p[1]); } return parseFloat(s.replace(',', '.')); };
  const fmtNum = (n) => String((n % 1 === 0) ? n : Number(n.toFixed(2))).replace('.', ',');
  const FRACTIONS = { '½': 0.5, '¼': 0.25, '¾': 0.75 };
  const parsed = qtyEls.map((el) => {
    const original = (el.getAttribute('data-v2r-qty') || el.textContent).trim();
    const fraction = original.match(/^(\d+)?\s?([½¼¾])(.*)$/);
    const match = original.match(/^([0-9.,\/]+)(?:\s?[–-]\s?([0-9.,]+))?(.*)$/);
    if (fraction) return { el, original, n: (fraction[1] ? parseFloat(fraction[1]) : 0) + FRACTIONS[fraction[2]], n2: NaN, unit: fraction[3] };
    if (match) return { el, original, n: toNum(match[1].trim()), n2: match[2] ? toNum(match[2]) : NaN, unit: match[3] };
    return { el, original, n: NaN, n2: NaN, unit: original };
  });
  let ratio = 1;
  const scale = (change) => {
    ratio = Math.max(1, ratio + change);
    if (countEl) countEl.textContent = ratio + '×';
    parsed.forEach((q) => {
      if (ratio === 1 || isNaN(q.n)) q.el.textContent = q.original;      // 1× = the recipe exactly as written
      else q.el.textContent = fmtNum(q.n * ratio) + (!isNaN(q.n2) ? '–' + fmtNum(q.n2 * ratio) : '') + q.unit;
    });
  };
  $$('[data-v2r-scale]').forEach((b) => b.addEventListener('click', () => scale(parseInt(b.getAttribute('data-v2r-scale'), 10) || 0)));

  /* ---------- the method rows: the whole row ticks ---------- */
  $$('[data-v2r-row]').forEach((row) => {
    row.addEventListener('click', (e) => {
      if (e.target.closest('a, label, input')) return;
      const box = row.querySelector('input[type="checkbox"]'); if (box) box.checked = !box.checked;
    });
  });

  /* ---------- »Hold skærmen tændt« ---------- */
  const wake = $('[data-v2r-wake]');
  if (wake && 'wakeLock' in navigator) {
    wake.hidden = false;
    const box = $('input', wake); let lock = null;
    const on = async () => { try { lock = await navigator.wakeLock.request('screen'); lock.addEventListener('release', () => { lock = null; }); } catch (e) { box.checked = false; } };
    const off = () => { if (lock) { lock.release().catch(() => {}); lock = null; } };
    box.addEventListener('change', () => { if (box.checked) on(); else off(); });
    // The browser lets go of the lock when the tab is hidden – take it again when the cook comes back
    document.addEventListener('visibilitychange', () => { if (box.checked && document.visibilityState === 'visible' && !lock) on(); });
  }

  /* ---------- the phone bar: which part is on screen ---------- */
  const tabs = $$('[data-v2r-tab]');
  if (tabs.length && 'IntersectionObserver' in window) {
    const mark = (name) => tabs.forEach((t) => t.classList.toggle('is-on', t.getAttribute('data-v2r-tab') === name));
    const io = new IntersectionObserver((entries) => { entries.forEach((e) => { if (e.isIntersecting) mark(e.target.getAttribute('data-v2r-sec')); }); }, { rootMargin: '-25% 0px -65% 0px' });
    $$('[data-v2r-sec]').forEach((s) => io.observe(s));
  }

  /* ---------- »Udskriv« ---------- */
  const print = $('[data-v2r-print]'); if (print) print.addEventListener('click', () => window.print());
})();
